import { Component, OnInit } from '@angular/core';
import { ApiServiceService } from '../../services/common/api-service.service';
import { environment } from 'src/environments/environment';
import { DomSanitizer, SafeUrl } from '@angular/platform-browser';
import Swal from 'sweetalert2';


@Component({

  selector:'app-merchant-portfolio',

  templateUrl:'./merchant-portfolio.component.html',

  styleUrls:['./merchant-portfolio.component.scss']

})


export class MerchantPortfolioComponent implements OnInit {



merchantId:any;
merchantData:any;

portfolio:any[]=[];
services:any[]=[];
selectedService:any=null;

showUpload=false;


editMode=false;


selectedPortfolioId:any=null;



selectedFiles:any[]=[];


previewUrl: any = null;



selectedFilter='all';



showImageViewer=false;


selectedImage='';



imageBaseUrl =
environment.apiUrl.replace('/api/v1.0','');





portfolioData:any={


title:'',

description:'',

media_type:'',

event_type:'',

event_location:'',

event_year:''


};





constructor(

private apiService:ApiServiceService,
private sanitizer: DomSanitizer

){}






ngOnInit():void{


this.merchantId =
localStorage.getItem('merchantId');

const userStr = localStorage.getItem('user');
if (userStr) {
  this.merchantData = JSON.parse(userStr);
}

if(this.merchantId){

this.getServices();

}


}








getServices(){
this.apiService
.getMerchantServices(this.merchantId)
.subscribe({
next:(res:any)=>{
this.services = res.data || [];
},
error:(err)=>{
console.log(err);
}
});
}

selectService(service:any){
this.selectedService = service;
this.getPortfolio();
}

backToFolders(){
this.selectedService = null;
this.portfolio = [];
}


getPortfolio(){
if(!this.selectedService) return;

this.apiService
.getServicePortfolio(this.selectedService._id)
.subscribe({

next:(res:any)=>{

this.portfolio =
res.data || [];

},

error:(err)=>{

console.log(err);

}

});


}








openUpload(){


this.resetForm();


this.showUpload=true;


}








openEdit(item:any){



this.editMode=true;


this.selectedPortfolioId=item._id;



this.portfolioData={


title:item.title,


description:item.description,


media_type:item.media_type,


event_type:item.event_type,


event_location:item.event_location,


event_year:item.event_year


};



this.previewUrl =
this.imageBaseUrl + item.media_url;



this.showUpload=true;


}








closeUpload(){


this.showUpload=false;


this.resetForm();


}








resetForm(){


this.editMode=false;


this.selectedPortfolioId=null;


this.selectedFiles=[];

this.previewUrl=null;



this.portfolioData={


title:'',

description:'',

media_type:'',

event_type:'',

event_location:'',

event_year:''


};


}








selectFile(event:any){

const files = event.target.files;

if(!files || !files.length){
return;
}

this.selectedFiles = Array.from(files);

// For preview, we'll just show the first one or a generic message
const firstFile = this.selectedFiles[0];

if(firstFile.type.startsWith('video')){
this.portfolioData.media_type='video';
}
else{
this.portfolioData.media_type='image';
}

const reader = new FileReader();

reader.onload=(e:any)=>{
    if(this.portfolioData.media_type === 'video') {
        this.previewUrl = this.sanitizer.bypassSecurityTrustUrl(e.target.result);
    } else {
        this.previewUrl = e.target.result;
    }
};

reader.readAsDataURL(firstFile);

}









savePortfolio(){


const formData =
new FormData();






if(this.selectedFiles && this.selectedFiles.length){
    for(let file of this.selectedFiles){
        formData.append('media', file);
    }
}






if(!this.editMode){



formData.append(

'merchant_id',

this.merchantId

);

formData.append(

'service_id',

this.selectedService._id

);



formData.append(

'media_type',

this.portfolioData.media_type

);



this.apiService
.addMerchantPortfolio(formData)
.subscribe({


next:()=>{


this.closeUpload();


this.getPortfolio();


},


error:(err)=>{
    console.log(err);
    Swal.fire({
        icon: 'error',
        title: 'Upload Failed',
        text: err.error?.message || 'Error uploading portfolio.'
    });
}


});



}

else{



this.apiService
.updateMerchantPortfolio(

this.selectedPortfolioId,

formData

)
.subscribe({


next:()=>{


this.closeUpload();


this.getPortfolio();


},


error:(err)=>{


console.log(err);


}


});


}



}









deletePortfolio(id:any){



const confirmDelete =
confirm(
'Are you sure you want to delete this portfolio item?'
);



if(!confirmDelete){

return;

}



this.apiService
.deleteMerchantPortfolio(id)
.subscribe({


next:()=>{


this.getPortfolio();


},


error:(err)=>{


console.log(err);


}


});


}








filteredPortfolio(){


if(this.selectedFilter==='all'){


return this.portfolio;


}



return this.portfolio.filter(

item=>
item.media_type===this.selectedFilter

);


}








selectedMediaType: string = 'image';

openMedia(mediaUrl: string, mediaType: string){
this.selectedImage = mediaUrl;
this.selectedMediaType = mediaType;
this.showImageViewer = true;
}






closeImage(){


this.showImageViewer=false;


this.selectedImage='';


}




}